module.exports = __webpack_public_path__ + "static/media/TitleExtensionExample@1x.f97320f543f8bac1b325a9e00ebd1a3b.jpg";